export default "__VITE_ASSET__DXgqqlwq__"